import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { Table, Icon, Grid, Button } from "semantic-ui-react";
import { getRequest } from "../../helpers/ApiHelpers";
import { withRouter } from "react-router-dom";
import CustomTable from "../CustomTable";

function TitleCompanies({ history }) {
  const [state, setState] = useState({
    initialLoading: true,
    noResults: false,
    titleCompanies: []
  });

  async function getTitleCompanies() {
    const result = await getRequest("/titleCompany/getTitleCompanies");
    if (result.success) {
      setState(state => ({
        ...state,
        titleCompanies: result.data,
        initialLoading: false
      }));
    }
  }

  useEffect(() => {
    getTitleCompanies();
  }, []);

  return (
    <React.Fragment>
      <div
        className={css({
          marginBottom: 19.75
        })}
      >
        <Grid>
          <Grid.Row columns={2} verticalAlign="middle">
            <Grid.Column floated="left">
              <div
                className={css({
                  fontFamily: "Fakt-Bold",
                  fontSize: 20,
                  lineHeight: 1.2,
                  color: "#47517b",
                  display: "inline-block",
                  marginRight: 64
                })}
              >
                Title Companies
              </div>
            </Grid.Column>
            <Grid.Column
              floated="right"
              className={css({ textAlign: "right" })}
            >
              <Button
                icon
                className="blueButton"
                onClick={() => history.push(`/admin/new-title-company`)}
              >
                <i className="fal fa-plus" />
              </Button>
              <span
                className={css({
                  fontFamily: "Fakt-Bold",
                  fontSize: 14,
                  color: "#000",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#00b8d4"
                  }
                })}
                onClick={() => history.push(`/admin/new-title-company`)}
              >
                New Title Company
              </span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <CustomTable
          customStyles={{
            "& tr td:first-of-type": {
              paddingLeft: "40.5px !important"
            },
            "& th": {
              position: "sticky",
              top: 0,
              zIndex: 1
            }
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Title Companies</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {state.titleCompanies.length < 1 && (
              <Table.Row>
                <Table.Cell>No title companies available</Table.Cell>
              </Table.Row>
            )}
            {state.titleCompanies.map(t => (
              <Table.Row key={t.id}>
                <Table.Cell
                  style={{
                    textAlign: "left"
                  }}
                >
                  <span
                    className={css({
                      "&:hover i": { color: "#00b8d4" },
                      cursor: "pointer",
                      verticalAlign: "top",
                      display: "inline-block"
                    })}
                    onClick={() =>
                      history.push(`/admin/edit-title-company/${t.id}`)
                    }
                  >
                    <Icon
                      style={{ paddingRight: 32.5 }}
                      className="fal fa-pen"
                    />
                  </span>
                  <React.Fragment>
                    <div
                      className={css({
                        display: "inline-block",
                        width: "calc(100% - 70px)"
                      })}
                    >
                      <span className={css({ fontFamily: "Fakt-Bold" })}>
                        {t.name}
                      </span>
                    </div>
                  </React.Fragment>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </CustomTable>
      </div>
    </React.Fragment>
  );
}

export default withRouter(TitleCompanies);
